import React from 'react'
import PropTypes from 'prop-types'

const AiUsageLog = (props) => {
  const {
    color = '#183560',
    backgroundColor = '#ffffff',
    classes = 'w-20',
  } = props
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classes}
    >
      <g clipPath="url(#clip0_13853_99575)">
        <path
          d="M18.3478 4.82321C18.3478 4.6558 18.2126 4.52009 18.0458 4.52009C17.879 4.52009 17.7437 4.6558 17.7437 4.82321V5.7515H16.8187C16.6519 5.7515 16.5167 5.88721 16.5167 6.05461C16.5167 6.22202 16.6519 6.35773 16.8187 6.35773H17.7437V7.28602C17.7437 7.45343 17.879 7.58914 18.0458 7.58914C18.2126 7.58914 18.3478 7.45343 18.3478 7.28602V6.35773H19.2728C19.4397 6.35773 19.5749 6.22202 19.5749 6.05461C19.5749 5.88721 19.4397 5.7515 19.2728 5.7515H18.3478V4.82321Z"
          fill={backgroundColor}
        />
        <path
          d="M5.36123 15.7339C5.36123 15.5665 5.22599 15.4308 5.05918 15.4308C4.89236 15.4308 4.75713 15.5665 4.75713 15.7339V17.1941H3.30205C3.13523 17.1941 3 17.3298 3 17.4972C3 17.6646 3.13523 17.8003 3.30205 17.8003H4.75713V19.2606C4.75713 19.428 4.89236 19.5637 5.05918 19.5637C5.22599 19.5637 5.36123 19.428 5.36123 19.2606V17.8003H6.81631C6.98312 17.8003 7.11836 17.6646 7.11836 17.4972C7.11836 17.3298 6.98312 17.1941 6.81631 17.1941H5.36123V15.7339Z"
          fill={backgroundColor}
        />
        <path
          d="M7.12194 10.0148L3.58376 11.4372C3.07783 11.6406 3.07783 12.3594 3.58376 12.5628L7.12194 13.9852C8.21842 14.426 9.10399 15.2731 9.5953 16.3511L11.5528 20.6459C11.768 21.118 12.4363 21.118 12.6515 20.6459L14.609 16.3511C15.1003 15.2731 15.9859 14.426 17.0824 13.9852L20.6206 12.5628C21.1265 12.3594 21.1265 11.6406 20.6206 11.4372L17.0824 10.0148C15.9859 9.57399 15.1003 8.7269 14.609 7.64894L12.6515 3.35407C12.4363 2.88197 11.768 2.88198 11.5528 3.35407L9.5953 7.64894C9.10399 8.7269 8.21842 9.57399 7.12194 10.0148Z"
          fill={backgroundColor}
        />
        <path
          d="M18.3478 4.82321C18.3478 4.6558 18.2126 4.52009 18.0458 4.52009C17.879 4.52009 17.7437 4.6558 17.7437 4.82321V5.7515H16.8187C16.6519 5.7515 16.5167 5.88721 16.5167 6.05461C16.5167 6.22202 16.6519 6.35773 16.8187 6.35773H17.7437V7.28602C17.7437 7.45343 17.879 7.58914 18.0458 7.58914C18.2126 7.58914 18.3478 7.45343 18.3478 7.28602V6.35773H19.2728C19.4397 6.35773 19.5749 6.22202 19.5749 6.05461C19.5749 5.88721 19.4397 5.7515 19.2728 5.7515H18.3478V4.82321Z"
          stroke={color}
          strokeWidth="1.5"
        />
        <path
          d="M5.36123 15.7339C5.36123 15.5665 5.22599 15.4308 5.05918 15.4308C4.89236 15.4308 4.75713 15.5665 4.75713 15.7339V17.1941H3.30205C3.13523 17.1941 3 17.3298 3 17.4972C3 17.6646 3.13523 17.8003 3.30205 17.8003H4.75713V19.2606C4.75713 19.428 4.89236 19.5637 5.05918 19.5637C5.22599 19.5637 5.36123 19.428 5.36123 19.2606V17.8003H6.81631C6.98312 17.8003 7.11836 17.6646 7.11836 17.4972C7.11836 17.3298 6.98312 17.1941 6.81631 17.1941H5.36123V15.7339Z"
          stroke={color}
          strokeWidth="1.5"
        />
        <path
          d="M7.12194 10.0148L3.58376 11.4372C3.07783 11.6406 3.07783 12.3594 3.58376 12.5628L7.12194 13.9852C8.21842 14.426 9.10399 15.2731 9.5953 16.3511L11.5528 20.6459C11.768 21.118 12.4363 21.118 12.6515 20.6459L14.609 16.3511C15.1003 15.2731 15.9859 14.426 17.0824 13.9852L20.6206 12.5628C21.1265 12.3594 21.1265 11.6406 20.6206 11.4372L17.0824 10.0148C15.9859 9.57399 15.1003 8.7269 14.609 7.64894L12.6515 3.35407C12.4363 2.88197 11.768 2.88198 11.5528 3.35407L9.5953 7.64894C9.10399 8.7269 8.21842 9.57399 7.12194 10.0148Z"
          stroke={color}
          strokeWidth="1.5"
        />
      </g>
      <defs>
        <clipPath id="clip0_13853_99575">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

AiUsageLog.propTypes = {
  color: PropTypes.string,
  classes: PropTypes.string,
  backgroundColor: PropTypes.string,
}

export default React.memo(AiUsageLog)
